import { ButtonGroup } from "@xola/ui-kit";
import React from "react";
import { DelegateRole, DelegateRoleMapping, SelectionState, UserRolesCopy } from "types";
import { useSeller } from "../../../hooks/useAccount";
import { ListFilter } from "../../Dashboard/Filters/ListFilter";
import { ItemSummary } from "../../Reports/AnalyticsProductPicker";

export const items = [
    {
        name: "All",
        key: "all",
    },
    {
        name: "Pending",
        key: "pending",
    },
    {
        name: "Active",
        key: "active",
    },
];

export interface DelegateListFilterValues {
    status: string;
    permissions: SelectionState;
}

interface DelegateListFilterProps {
    filters: DelegateListFilterValues;
    onUpdateFilters: (filters: DelegateListFilterValues) => void;
}

export const DelegateListFilter = ({ filters, onUpdateFilters }: DelegateListFilterProps) => {
    const seller = useSeller();
    const isAffiliateLoginEnabled = seller.preferences.affiliate?.allowLogin ?? false;
    const activeIndex = items.findIndex((item) => item.key === filters.status);

    const handlePermissionsChange = (permissions: SelectionState) => {
        const updatedFilters = { ...filters, permissions };
        onUpdateFilters(updatedFilters);
    };

    const handleStatusChange = (index: number) => {
        const updatedFilters = { ...filters, status: items[index].key };
        onUpdateFilters(updatedFilters);
    };

    return (
        <div className="flex flex-row items-center justify-between border-b border-gray-light px-10 py-3">
            <div className="flex w-full flex-row items-center justify-between">
                <div className="flex w-full flex-row items-center justify-start space-x-1 xl:space-x-4">
                    <div>
                        <ListFilter
                            label="User Role"
                            title="Filter by User Roles"
                            fetch={() => fetchPermissions(isAffiliateLoginEnabled)}
                            target={ItemSummary}
                            value={filters.permissions}
                            onChange={handlePermissionsChange}
                        />
                    </div>

                    <div>
                        <ButtonGroup
                            className="px-2 align-top"
                            size="medium"
                            value={activeIndex}
                            onChange={handleStatusChange}
                        >
                            {items.map((type) => {
                                return <ButtonGroup.Button key={type.key}>{type.name}</ButtonGroup.Button>;
                            })}
                        </ButtonGroup>
                    </div>
                </div>
            </div>
        </div>
    );
};

const fetchPermissions = (includeAffiliates = false) => {
    const data = includeAffiliates
        ? [
              ...DelegateRoleMapping,
              {
                  name: UserRolesCopy.ROLE_AFFILIATE,
                  id: DelegateRole.AFFILIATE,
                  text: "",
              },
          ]
        : DelegateRoleMapping;

    return { data, isLoading: false };
};
